import React, { createContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import CommonUtils from "services/common/utils";

export type HeaderTabsContextProps = {
  headerTab: string | undefined;
  setHeaderTab: (headerTabs: string) => void;
  headerTitle: string | String | undefined;
};

const HeaderTabsContext = createContext<HeaderTabsContextProps | null>(null);

type Props = {
  children: JSX.Element;
};

export function HeaderTabsProvider({ children }: Props) {
  const [headerTab, setHeaderTab] = useState<string>();
  const [headerTitle, setHeaderTitle] = useState<String>();
  const intl = useIntl();

  useEffect(() => {
    function updatePageTitleFromLocation() {
      const currentModule =
        CommonUtils.getModuleFromPath(headerTab ?? "") || "login";
      setHeaderTitle(intl?.messages[`header.tabs.${currentModule}`].toString());
    }
    updatePageTitleFromLocation();
  }, [intl, headerTab]);

  return (
    <HeaderTabsContext.Provider
      value={{ headerTab, setHeaderTab, headerTitle }}
    >
      {children}
    </HeaderTabsContext.Provider>
  );
}

export const useHeaderTabsContext = () => React.useContext(HeaderTabsContext);
